import { render, staticRenderFns } from "./DynamicDocumentForm.vue?vue&type=template&id=749789a8&scoped=true"
import script from "./DynamicDocumentForm.vue?vue&type=script&lang=js"
export * from "./DynamicDocumentForm.vue?vue&type=script&lang=js"
import style0 from "./DynamicDocumentForm.vue?vue&type=style&index=0&id=749789a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749789a8",
  null
  
)

export default component.exports